import { render, staticRenderFns } from "./2018_antrag_einfach.vue?vue&type=template&id=fceffd50&"
import script from "./2018_antrag_einfach.vue?vue&type=script&lang=js&"
export * from "./2018_antrag_einfach.vue?vue&type=script&lang=js&"
import style0 from "./2018_antrag_einfach.vue?vue&type=style&index=0&id=fceffd50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports